import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {DropdownModel} from '../../../models/component/dropdown.model';

@Component({
  selector: 'app-evo-lang-dropdown',
  templateUrl: './evo-lang-dropdown.component.html',
  styleUrls: ['./evo-lang-dropdown.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EvoLangDropdownComponent),
    multi: true
  }]
})
export class EvoLangDropdownComponent implements OnInit, ControlValueAccessor {

  public static Types = {
    country: 'country',
    culture: 'culture'
  };

  @Input() cultureDropdownList = CultureModel.dropdownList();

  _currentValue: DropdownModel = null;
  _countryDropdownList: DropdownModel[] = CountryModel.privateDropdownList();

  @Input() showTitle = true;
  /**
   * The other type of dropdown is country.
   */
  @Input() type: string = EvoLangDropdownComponent.Types.country;
  @Input() autoselect = false;
  @Input() dropdownHeight: string = null;
  @Input() isDisabled = false;

  @Output() valueChangedEvent = new EventEmitter<string>();

  @Input('currentValue')
  set currentValue(value: any) {
    this.writeValue(value);
  }

  @Input('countryDropdownList')
  set countryDropdownList(values:  DropdownModel[]) {

    this._countryDropdownList = values;

    if (this.autoselect === true && !this._currentValue) {
      this._currentValue = this._countryDropdownList[0];
      this.writeValue(this._currentValue);
    }

  }

  get countryDropdownList(): DropdownModel[] {
    return this._countryDropdownList;
  }

  propagateChange = (_: any) => {};

  constructor() { }

  ngOnInit() {

  }

  getCurrentValue(): string {

    if (this._currentValue) {
      return this._currentValue.value;
    }

    return '';
  }

  getAutoSelectValue(): DropdownModel {

    if (this._currentValue === null && this.autoselect === true) {

      if (this.type === EvoLangDropdownComponent.Types.country) {

        this._currentValue = CountryModel.dropdownList()[0];
        this.propagateChange(this._currentValue.key);

      } else if (this.type === EvoLangDropdownComponent.Types.culture) {

        this._currentValue = CultureModel.dropdownList()[0];
        this.propagateChange(this._currentValue.key);

      }

    }

    if (this._currentValue !== null && this._currentValue !== undefined) {

      return this._currentValue;
    }

    return null;
  }

  getDropdownList(): DropdownModel[] {

    if (this.type === EvoLangDropdownComponent.Types.culture) {
      return this.cultureDropdownList;
    } else if (this.type === EvoLangDropdownComponent.Types.country) {
      return this._countryDropdownList;
    }

    return [];
  }

  getTitle(): string {

    if (this.type === EvoLangDropdownComponent.Types.culture) {
      return 'reusable.cultureTitle';
    } else if (this.type === EvoLangDropdownComponent.Types.country) {
      return 'reusable.countryTitle';
    }

    return '';
  }

  getPlaceholder(): string {

    if (this.type === EvoLangDropdownComponent.Types.culture) {
      return 'reusable.selectCulture';
    } else if (this.type === EvoLangDropdownComponent.Types.country) {
      return 'reusable.selectCountry';
    }

    return '';
  }

  onValueChanged(value: string) {

    if (this.valueChangedEvent) {

      this.valueChangedEvent.emit(value);
      this.propagateChange(value);

    }

  }

  /**
   * @description Value Accessor Methods
   *
   */
  writeValue(obj: any): void {

    if (obj !== null && obj !== undefined) {

      if (typeof (obj) === 'number') {

        const index = <number>obj;

        if (index < this.getDropdownList().length) {
          this._currentValue = this.getDropdownList()[index];
          this.propagateChange(this._currentValue.key);
        } else {
          this.propagateChange(null);
        }

      } else if (typeof (obj) === 'string') {

        const key = <string>obj;

        let index = -1;
        let counter = 0;
        for (const el of this.getDropdownList()) {

          if (el.key === key) {
            index = counter;
            break;
          }
          counter += 1;
        }

        if (index !== -1) {
          this._currentValue = this.getDropdownList()[index];
          this.propagateChange(this._currentValue.key);
        } else {
          this.propagateChange(null);
        }

      } else if (typeof (obj) === 'object') {

        let index = -1;

        let counter = 0;
        for (const el of this.getDropdownList()) {

          if (el.key === obj.key) {
            index = counter;
          }

          counter += 1;
        }

        if (index !== -1) {
          this._currentValue = this.getDropdownList()[index];
          this.propagateChange(this._currentValue.key);
        } else {
          this.propagateChange(null);
        }

      }

    } else {
      this._currentValue = null;
    }
  }

  registerOnChange(fn: any): void {

    this.propagateChange = fn;
    if (this._currentValue) {
      this.propagateChange(this._currentValue.key);
    }

  }

  registerOnTouched(fn: any): void {
  }

}
